import ComponentLayout from "../../../../src/layouts/component-layout";
import { Label } from '@primer/react';
import * as React from 'react';
export default {
  ComponentLayout,
  Label,
  React
};